<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :maxwidth-container="$vuetify.breakpoint.lgAndUp ? '750px' : '600px'"
    >
      <Loading v-if="loading" />
      <ErrorServidor v-else-if="erro" />
      <template v-else>
        <CorrigirStepper v-if="corrigirDados" />
        <DadosBancariosStepper
          v-else-if="possuiDadosBancarios"
          :iniciar-passo="irParaPasso"
          :dados-bancarios="dadosContaBancaria"
          @mudarDadosBancarios="manterAlterarDados"
        />
        <BoletoStepper
          v-else-if="solicitaDadosBancarios"
          :iniciar-passo="irParaPasso"
          @manterDadosBancarios="manterAlterarDados"
        />
        <CartaoStepper v-else />
      </template>
    </InternaMain>
  </Wrapper>
</template>

<script>

import { mapGetters } from 'vuex';
import api from '@/api';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import BoletoStepper from '@/components/SolicitacaoReembolso/Boleto/BoletoStepper.vue';
import CartaoStepper from '@/components/SolicitacaoReembolso/Cartao/CartaoStepper.vue';
import DadosBancariosStepper from '@/components/SolicitacaoReembolso/DadosBancarios/DadosBancariosStepper.vue';
import CorrigirStepper from '@/components/SolicitacaoReembolso/CorrigirDados/CorrigirStepper.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'SolicitacaoReembolso',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    BoletoStepper,
    CartaoStepper,
    DadosBancariosStepper,
    CorrigirStepper,
    ErrorServidor,
    Loading,
  },

  data: () => ({
    dadosContaBancaria: {},
    erro: false,
    mudarDadosBancarios: false,
    irParaPasso: 1,
  }),

  computed: {
    ...mapGetters(['dadosCompra', 'alterarDadosBancarios']),

    solicitaDadosBancarios() {
      return this.dadosCompra.reembolso
        && (
          this.dadosCompra.boleto
        || this.dadosCompra.is_online_debt
        || this.dadosCompra.is_boleto_in_installments
        || this.dadosCompra.cartaoDebito
        );
    },

    possuiDadosBancarios() {
      return this.solicitaDadosBancarios
        && this.dadosContaBancaria.has_bank_account
        && !this.mudarDadosBancarios;
    },

    cartaoCredito() {
      return this.dadosCompra.cartaoCredito && this.dadosCompra.reembolso;
    },
    corrigirDados() {
      if (this.$route.name === 'corrigir-dados-bancarios') return true;

      return false;
    },

    loading() {
      return this.solicitaDadosBancarios
        && !this.erro
        && Object.keys(this.dadosContaBancaria).length === 0;
    },
  },

  mounted() {
    this.verificaDados();
  },

  methods: {
    async verificaDados() {
      if (Object.keys(this.dadosCompra).length === 0) {
        this.$router.push('/minhas-compras');
      }

      if (this.solicitaDadosBancarios) {
        try {
          const { data } = await api.get('/refund-request/bank-account', {
            params: {
              order_id: this.dadosCompra.venda,
            },
          });

          this.dadosContaBancaria = data;
        } catch (error) {
          this.erro = true;
        }
      }
    },

    manterAlterarDados() {
      this.irParaPasso = 2;
      this.mudarDadosBancarios = this.alterarDadosBancarios;
    },
  },

};
</script>
